var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81556 28C2.15753 27.9999 2.48548 27.8657 2.72725 27.6269L15.6224 14.8925C15.8642 14.6537 16 14.3298 16 13.9922C16 13.6545 15.8642 13.3307 15.6224 13.0919L2.72725 0.357469C2.48405 0.125502 2.15831 -0.00285329 1.8202 4.81393e-05C1.48209 0.00294957 1.15867 0.136876 0.919579 0.372981C0.680491 0.609087 0.544872 0.928482 0.541935 1.26237C0.538997 1.59626 0.668973 1.91794 0.90387 2.15811L12.8874 13.9922L0.90387 25.8262C0.723582 26.0043 0.600813 26.2312 0.551079 26.4782C0.501346 26.7252 0.526882 26.9812 0.62446 27.2138C0.722038 27.4465 0.887277 27.6454 1.09929 27.7853C1.3113 27.9252 1.56056 27.9999 1.81556 28Z",
    fill: "#C7ECE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.3cbc4621.svg";
export { ForwardRef as ReactComponent };